export function validateDocumentNumber(documentNumber) {
  if (!documentNumber) return false;
  
  documentNumber = documentNumber.replace(/[^\d]/g, '');
  
  if (documentNumber.length !== 11) return false;
  
  if (/^(\d)\1+$/.test(documentNumber)) return false;
  
  let sum = 0;
  let remainder;
  
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(documentNumber.substring(i - 1, i)) * (11 - i);
  }
  
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(documentNumber.substring(9, 10))) return false;
  
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(documentNumber.substring(i - 1, i)) * (12 - i);
  }
  
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(documentNumber.substring(10, 11))) return false;
  
  return true;
}

export function validateDate(date) {
  if (!date) return false;

  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(date)) return false;
  
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);
  
  return (
    dateObj.getDate() === day &&
    dateObj.getMonth() === month - 1 &&
    dateObj.getFullYear() === year
  );
}

export function validateName(name) {
  if (!name) return false;
  
  return name.length >= 5 && name.includes(' ');
}

